import {
  SiteData,
  NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS,
  DEFAULT_INTEGRATIONS,
} from '../client-data/site-data';
import { loadedData } from './metrics-loader';
import { GTM } from './google-tag-manager';

class Metrics {
  constructor(data) {
    this._data = data;
    this.metricsData = new SiteData(data);
  }

  pageLeave() {
    this.metricsData.pageLeave();
  }

  pageLoad() {
    this.metricsData.pageLoad();
  }

  logEvent(eventName, interactionData, immediate = false, options = {}) {
    // eslint-disable-next-line no-param-reassign
    options.integrations = this.makeIntegrations();

    GTM.pushEvent(eventName, interactionData);

    const sentData = this.metricsData.logEvent(
      eventName,
      interactionData,
      immediate,
      options
    );
    // console.log('EVENT!', eventName, sentData);
    return sentData;
  }

  navigateTo(page) {
    // Re-init the metrics on a new page

    // TODO: fix this to load the same data source as metrics-loader
    // so that navigating between courses still works
    if (this.metricsData) {
      this.metricsData.destroy();
      this.metricsData = null;
    }

    const data = Object.assign({}, this._data, {
      'page-id': page.id,
      'page-path': page.path,
    });

    this.metricsData = new SiteData(data);
  }

  identify(user, traits) {
    const options = { integrations: this.makeIntegrations() };
    this.metricsData.identify(user, traits, options);
  }

  makeIntegrations() {
    const { userEducatorSubscriptionPlan } = this._data;
    let integrations = { ...DEFAULT_INTEGRATIONS };

    if (!userEducatorSubscriptionPlan) {
      integrations = {
        ...integrations,
        ...NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS,
      };
    }

    return integrations;
  }
}

export const metrics = new Metrics(loadedData);
